import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { Map } from 'immutable';

export const betbookCreateAnalysisBetIds$ = pathSubscription(['betbook', 'create-analysis-betIds']);
export const betbookGamingOpportunities$ = pathSubscription(['betbook', 'gaming-opportunities']);
export const betbookGamingOpportunityTickets$ = pathSubscription(['betbook', 'gaming-opportunity-tickets']);
export const betbookGamingOpportunityWithTicket$ = pathSubscription(['betbook', 'gaming-opportunity']);
export const betbookPostFilterType$ = pathSubscription(['betbook', 'posts', 'filter', 'postType']);
export const defaultTitle$ = pathSubscription(['betbook', 'newPost', 'title', 'default-text']);

export const betbookFilterExpirationTag$ = pathSubscription(['betbook', 'posts', 'filter', 'expirationTag']);
export const betbookFilterBetCount$ = pathSubscription(['betbook', 'posts', 'filter', 'betCount']);
export const betbookFilterOdds$ = pathSubscription(['betbook', 'posts', 'filter', 'odds']);
export const betbookFilterResultsCount$ = pathSubscription(['betbook', 'posts', 'results-count']);
export const betbookFilterSportIds$ = pathSubscription(['betbook', 'posts', 'filter', 'sportIds']);
export const betbookFilterStake$ = pathSubscription(['betbook', 'posts', 'filter', 'stake']);
export const betbookFilterWin$ = pathSubscription(['betbook', 'posts', 'filter', 'win']);
export const betbookFiltersConfig$ = pathSubscription(['betbook', 'posts', 'filter-config']);

export const filterByDate$ = pathSubscription(['betbook', 'posts', 'filter', 'byDate']);
export const betbookTopEventsData$ = pathSubscription(['betbook', 'topEvents', 'data', 'topEventsSelections']);
export const betbookTopEventsMatches$ = pathSubscription(['betbook', 'topEvents', 'data', 'matches'], false);
export const betbookTopEventsMatch$$ = parametric(matchId =>
    pathSubscription(['betbook', 'topEvents', 'data', 'matches', `${matchId}`], false)
);
export const topEventsFilterByDate$ = pathSubscription(['betbook', 'topEvents', 'filter', 'byDate']);
export const topEventsFilterBySport$ = pathSubscription(['betbook', 'topEvents', 'filter', 'bySport']);
export const analysesLimitReached$ = pathSubscription(['betbook', 'limits', 'reachLimits']);
export const canHaveAnalysisReward$ = pathSubscription(['betbook', 'limits', 'canHaveAnalysisReward']);
export const betbookPosts$ = pathSubscription(['betbook', 'posts', 'list']);
export const hasMarketingAgreement$ = subscription(db => {
    const isMarketing = db.getIn(['account', 'userData', 'marketingAgreement']);
    if (isMarketing !== undefined) {
        return isMarketing;
    } else {
        return db.getIn(['account', 'user', 'marketingAgreement']);
    }
});

export const betbookLastParam$ = pathSubscription(['betbook', 'lastParam']);

export const betbookBetsIds$ = subscription(db => {
    const isNikeOne = db
        .getIn(['nikeone', 'boxStore', 'betbook', 'bets'], Map())
        .keySeq()
        .toArray();
    if (isNikeOne.length > 0) {
        return isNikeOne;
    } else
        return db
            .getIn(['betbook', 'bets', 'byId'], Map())
            .keySeq()
            .toArray();
});
